module.exports = __webpack_public_path__ + "static/media/mobile2.38289fdf.png";